import { Guid } from './Shared';

export interface Company {
	guid: Guid;
	companyName: string;
	companyOverview: string;
	type: number;
	status: number;
	ownershipStructure: OwnershipStructure;
	url: string;
	taxIdNumber: string;
	followupDate: string; // Date-Time
	numberOfEmployees: number;
	treasuryMgmtFees: number;
	foreignExchangeVolume: number;
	sizeOf401Kplan: number;
	outstandingSwapValue: number;
	source: number;
	reasonForComing: string;
	referredBy: string;
	notes: string;
	accountManagerPersonId: number;
	createdOn: string; // Date-Time
	modifiedOn: string; // Date-Time
	imageFileName: string;
	existingBank: string;
	existingAccountant: string;
	existingLawFirm: string;
	isGovtContractor: true;
	percentGovtRevenue: number;
	emailDomain: string;
	bankId: number;
	revenueRange: number;
	ebitdaRange: number;
	totalDebt: number;
	numExistingFacilities: number;
	salesRepPersonId: number;
	fiscalEndMonth: number;
	fiscalEndDay: number;
	requiresFinancialApproval: true;
	requiresCovenantApproval: true;
	canAccessRelatedCompanies: true;
	isManagingDebt: true;
	isManagingFinancials: true;
	isSoftwareSaasCompany: true;
	customerType: number;
	showCreditExplorer: true;
	billingEmailAddress: string;
	restrictedAccess: true;
	covenantReminderTiming: number;
	currency: string;
	accountingSystemType: number;
	ndaEffectiveDate: string; // Date-Time
	ndaExpirationDate: string; // Date-Time
}

export const OwnershipStructureMap = {
	Unknown: 'Unknown',
	Private: 'Private Independently Owned',
	Public: 'Public Company',
	Private_Equity_Owned: 'Private Equity Backed',
	ESOP_Owned: 'ESOP Owned',
	Foreign_Parent_Owned: 'Foreign Parent Owned',
	NonProfit: 'Non-Profit',
	Other: 'Other',
	IndependentSponsorBacked: 'Independent Sponsor Backed',
};

export type OwnershipStructure = keyof typeof OwnershipStructureMap;
